import { Input } from 'antd';
import React from 'react';

const Emails = ({ disabled = false, value='',onChange }) => {
    return (
        <div>
            <Input variant='underlined' type='email'
            placeholder="Email"
            disabled={disabled}
            style={{ width: '60%' }}
            value={value}
            onChange={e => onChange(e.target.value)}
            />
        </div>
    );
};

export default Emails;